"use client"

import * as React from "react"
import { Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"

export function ThemeToggle() {
  const [mounted, setMounted] = React.useState(false)
  const { theme, setTheme } = useTheme()

  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return (
    <button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      aria-label="Alternar tema claro/escuro"
      className="relative inline-flex min-h-11 min-w-11 lg:min-h-9 lg:min-w-9 items-center justify-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted/40 active:bg-muted/60 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-amber)]/40"
    >
      <Sun className="h-[18px] w-[18px] transition-all dark:hidden" />
      <Moon className="h-[18px] w-[18px] transition-all hidden dark:block" />
      <span className="sr-only">Alternar tema</span>
    </button>
  )
}
